exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n.dear-applicant{\n    text-align:left !important;\n}\n\n@media (min-width: 1200px){\n    .container {\n        max-width: 700px;\n    }\n}\n\n@media (min-width: 992px){\n    .container {\n        max-width: 700px;\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/SynergiPartners 7-Eleven Screening/src/app/employee-search/employee-search.component.css
// module id = ../../../../../src/app/employee-search/employee-search.component.css
// module chunks = main